const linkCards = [
  {
    id: 0,
    link:
      'https://auteco.vteximg.com.br/arquivos/ids/190156-1000-1000/camion_electrico_stark_foto2.jpg?v=637191079515600000',
  },
  {
    id: 1,
    link:
      'https://auteco.vteximg.com.br/arquivos/ids/212729-1100-550/Camioneta_Pickup_Donfeng_Rich6ev_Blanco_foto02.jpg?v=637778035257230000',
  },
  {
    id: 2,
    link: 'https://auteco.vteximg.com.br/arquivos/ids/219084-600-600.webp',
  },
  {
    id: 3,
    link:
      'https://auteco.vteximg.com.br/arquivos/ids/170560-1100-550/starker_super_soco_tc1900_azul_2019-foto1.jpg?v=636785076252770000',
  },
  {
    id: 4,
    link:
      'https://storage.googleapis.com/lucia-static.lucia.com.co/page/img/repuestos.png',
  },
  {
    id: 5,
    link:
      'https://images.unsplash.com/photo-1518791841217-8f162f1e1131?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=800&q=60',
  },
  {
    id: 6,
    link:
      'https://media.autecomobility.com/recursos/imagenes/Departamentos/vehiculos-carga/motocarros.jpg',
  },
  {
    id: 7,
    link:
      'https://yt3.ggpht.com/ytc/AAUvwngIFy76DdIp6VN1Rv9_H4SF73cyagBfejGcWfnK=s900-c-k-c0x00ffffff-no-rj',
  },
  { id: 8, link: 'https://i.ytimg.com/vi/J7AJb_LHpMM/maxresdefault.jpg' },
  { id: 9, link: 'https://lucia-static.lucia.com.co/img/page/postventa.jpeg' },
]

export default linkCards
